import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {
            pt
        },
        current: 'pt',
    },
    theme: {
        dark: false,
        default: 'light',
        themes: {
            light: {
                primary: '#072388',
                secondary: '#ff8c00',
                'text-pink': '#072388',
                'text-white': '#FFFFFF',
                bg: '#ccd4dd',
                bg2: '#f6f6f6',
                accent: '#45b986',
                error: '#FF5252',
                info: '#45b986',
                success: '#6AC79E',
                warning: '#FB8C00',
                primaryMn: '#ffcc00',
                secondaryMn: '#6AC79E',
                terceira: '#4D3C56',
                quarta: '#bdbabe',
                fundoBranco: '#f2f2f2',
                textos: '#44444c',
            },
            dark: {
                primary: '#072388',
                secondary: '#ff8c00',
                'text-pink': '#072388',
                'text-white': '#FFFFFF',
                bg: '#ccd4dd',
                bg2: '#f6f6f6',
                accent: '#FF4081',
                error: '#FF5252',
                info: '#2196F3',
                primaryMn: '#ff8c00',
                success: '#4CAF50',
                warning: '#FB8C00',
            },
        },
        options: {
            themeCache: {
                get: key => localStorage.getItem(key),
                set: (key, value) => localStorage.setItem(key, value),
            },
            customProperties: true
        },
        breakpoint: {
            thresholds: {
                xs: 600,
                sm: 960,
                md: 1264,
                lg: 1904,
            },
        },
    },

});